import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, inject, OnInit } from '@angular/core';
import { AiService } from '../../../service/ai.service';

@Component({
  selector: 'app-mentorselect',
  standalone: false,
  templateUrl: './mentorselect.component.html',
  styleUrl: './mentorselect.component.scss'
})
export class MentorselectComponent implements OnInit {
  readonly dialog = inject(MatDialogRef<MentorselectComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);
  readonly aiService = inject(AiService)

  agentList: any[] = [];


  async ngOnInit() {
    this.agentList = await this.aiService.getAgentsList();
    // console.log(this.data);

    if (this.data.urlAgentId && this.data.urlAgentId !== null) {
      let mentor = await this.agentList.find(agent => agent.id === this.data.urlAgentId);
      if (mentor) {
        this.selectMentor(mentor);
      }
    }
  }

  selectMentor(mentor: any) {
    this.dialog.close(mentor);
  }
  close() {
    this.dialog.close();
  }
}
